

import {Component, Mixins, Prop} from "vue-property-decorator";
import {
  deleteUser,
  generateNewApiToken,
  getUsers,
  loginAsUserUser
} from "@pazion/pazion-core/src/services/auth-service";
import {DataTableHeader} from "vuetify";
import PazClipboardButton from "@pazion/pazion-core/src/components/controls/PazClipboardButton.vue";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import PazConfirmation from "@pazion/pazion-core/src/components/utils/PazConfirmation.vue";
import PazTextSearch from "@pazion/pazion-core/src/components/controls/PazTextSearch.vue";
import PazAjaxTable from "@pazion/pazion-core/src/components/layout/PazAjaxTable.vue";
import PazRefreshButton from "@pazion/pazion-core/src/components/controls/PazRefreshButton.vue";
import pazUserEditDialog from "@pazion/pazion-core/src/views/user/modals/pazEditUserModal.vue";
import {authentication} from "@pazion/pazion-core/src/store";
import PermissionService from "@pazion/pazion-core/src/services/permission-service";
import AuthUsermixin from "@pazion/pazion-core/src/mixins/AuthUser.mixin";

@Component({
  components: {
    PazClipboardButton,
    PazTooltipButton,
    PazConfirmation,
    PazTextSearch,
    PazAjaxTable,
    PazRefreshButton,
    pazUserEditDialog
  },
})
export default class UserListing extends Mixins(PermissionService, AuthUsermixin) {

  @Prop({default: false}) public tablePreLoading?: boolean;

  public token: string = '';
  public loading: boolean = true;
  @Prop({default: false})
  public allowEditUser!: boolean;
  public search: string = "";
  public items: object[] = [];
  public headers: DataTableHeader[] = [];

  showEditUserDialog: boolean = false;
  selectedUserId: number | null = null;


  $refs!: {
    confirm: PazConfirmation;
    response: PazConfirmation;
    confirmWarn: PazConfirmation;
  };

  get canShowTenant() {
    return this.hasFeatureFlag("tenantManagement");
  }

  private $ediApiManagement: boolean | undefined;

  get canEdit(): boolean {
    return this.isAdmin || this.allowEditUser;
  }

  setHeaders() {
    this.headers = [];
    this.headers.push({
      text: "username(email)",
      align: "start",
      sortable: true,
      value: "username",
    });

    if (this.$userfieldFirstName) {
      this.headers.push(
          {
            text: "Firstname",
            align: "start",
            sortable: true,
            value: "nameFirst",
          }
      );
    }
    if (this.$userfieldSalutation) {
      this.headers.push(
          {
            text: "Salutation",
            align: "start",
            sortable: true,
            value: "salutation",
          }
      );
    }
    if (this.canShowTenant) {
      this.headers.push(
          {
            text: "Tenant",
            align: "start",
            sortable: true,
            value: "tenantName",
          }
      );
    }
    this.headers.push(
        {
          text: this.$userfieldFirstName ? "Lastname" : "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: "role",
          align: "start",
          sortable: true,
          value: "role",
        },
        {
          text: "Action",
          align: "end",
          sortable: false,
          value: "extra",
        });
  }

  get hasUserfieldFirstname() {
    return this.$userfieldFirstName;
  }

  get hasUserFieldSalutation() {
    return this.$userfieldSalutation;
  }

  get canLoginAsUser(): boolean {
    return this.hasProfileFlag("userManagement.loginAs");
  }

  hasApiToken(user: any) {
    if (user['apiSecret'] == null || user['apiSecret'] == '') {
      return false;
    }
    return true;
  }

  async confirmNewApiToken(user: any) {
    this.token = '';
    let extraMessage = '';
    let alreadyHasToken = this.hasApiToken(user);
    if (alreadyHasToken) {
      extraMessage = `Warning: The currently set api key will become <strong>invalid</strong>.<br/><br/>`;
    }
    const confirm = await this.$refs.confirmWarn.openConfirmDialog(
        "Warning",
        extraMessage +
        `Do you want to regenerate a token for '${user.name}'?`
    );
    if (confirm) {
      let rsp = await generateNewApiToken(user.id);
      this.token = rsp.token;
      await this.$refs.response.openConfirmDialog(
          "Confirmation",
          ''
      );
    }
  }

  async fetchData() {
    this.loading = true;
    this.items = await getUsers();
    this.loading = false;
  }

  async confirmDeletion(user: any) {
    const confirm = await this.$refs.confirm.openConfirmDialog(
        "Delete",
        "Are you sure you want to delete `" + user.name + "`?"
    );
    if (confirm) {
      const response = await deleteUser(user.id);
      if (response) await this.fetchData();
    }
  }

  canLoginAs(item: object): boolean {
    return 'administrator' !== item?.role?.nameTech;
  }

  async loginAsUser(id: number | string, name: string) {
    if (!this.isAdmin) {
      return;
    }
    let rsp = await loginAsUserUser(id.toString(), name);
    await authentication.loginAsUser(rsp);
    await authentication.verifyUser();
    await this.$router.push({name: 'Home'});
  }

  triggerUserEditDialog(id: number | null, isClose: boolean) {
    this.selectedUserId = id;
    this.showEditUserDialog = !isClose;
  }

  get isUsingEdiApi(): boolean {
    if (this.$ediApiManagement == undefined) {
      return false;
    }
    return this.$ediApiManagement;

  }

  public mounted() {
    this.setHeaders();
    this.fetchData();
  }
}
